<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">Meeting Room Order</h3>
      </div>
      <div class="content-header-right col-md-8 col-12">
        <div class="breadcrumbs-top">
          <div class="breadcrumb-wrapper mr-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/meetingroom">Meeting Room Order</router-link></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <form class="form-horizontal" id="meetingroom-form" v-on:submit.prevent="order">
                  <fieldset class="form-group">
                    <button type="button" class="btn btn-primary btn-sm scan-now" v-on:click="scan">Scan QR</button>
                    <label for="room">Meeting Room *</label>
                    <select class="form-control" id="room" v-model="room" required>
                      <option value="">Select</option>
                      <option v-bind:value="room.id" v-for="room in rooms" v-bind:key="room.id">{{room.name}}</option>
                    </select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="time">Time *</label>
                    <select class="form-control" id="time" v-model="time" required>
                      <option value="ASAP">ASAP</option>
                      <option value="5:00">5:00</option>
                      <option value="5:30">5:30</option>
                      <option value="6:00">6:00</option>
                      <option value="6:30">6:30</option>
                      <option value="7:00">7:00</option>
                      <option value="7:30">7:30</option>
                      <option value="8:00">8:00</option>
                      <option value="8:30">8:30</option>
                      <option value="9:00">9:00</option>
                      <option value="9:30">9:30</option>
                      <option value="10:00">10:00</option>
                      <option value="10:30">10:30</option>
                      <option value="11:00">11:00</option>
                      <option value="11:30">11:30</option>
                      <option value="12:00">12:00</option>
                      <option value="12:30">12:30</option>
                      <option value="13:00">13:00</option>
                      <option value="13:30">13:30</option>
                      <option value="14:00">14:00</option>
                      <option value="14:30">14:30</option>
                      <option value="15:00">15:00</option>
                      <option value="15:30">15:30</option>
                      <option value="16:00">16:00</option>
                      <option value="16:30">16:30</option>
                      <option value="17:00">17:00</option>
                      <option value="17:30">17:30</option>
                      <option value="18:00">18:00</option>
                      <option value="18:30">18:30</option>
                      <option value="19:00">19:00</option>
                      <option value="19:30">19:30</option>
                      <option value="20:00">20:00</option>
                    </select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="date">Date *</label>
                    <input type="text" id="date" v-model="date" class="form-control datepicker" required />
                  </fieldset>

                  <div class="form-group text-center">
                    <input type="submit" class="btn btn-block btn-glow btn-primary" value="Place Order">
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'meetingroom',
  data: function () {
    return {
      room: '',
      date: '',
      time: '',
      rooms: []
    }
  },
  mounted: function () {
    var that = this
    $('.datepicker').datepicker({
      autoclose: true,
      format: 'yyyy-mm-dd'
    })

    $.ajax({
      beforeSend: function (xhr) {
        $.showLoading()
        if (window.localStorage.getItem('token')) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        }
      },
      complete: function () {
        $.hideLoading()
      },
      url: this.$config.apiUrl + 'basic/boardrooms',
      type: 'get',
      success: function (data) {
        that.rooms = data.data
      }
    })
  },
  methods: {
    order: function () {
      if ($('#date').val() === '') {
        alert('You need to select a date')
      }

      var time = this.time
      if (time === 'ASAP') {
        var date = new Date()
        time = parseInt(date.getHours()) + ':' + parseInt(date.getMinutes())
      }

      window.localStorage.setItem('boardroomId', this.room)
      window.localStorage.setItem('boardroomTime', time)
      this.$router.push('/preorder/' + $('#date').val() + '/1/Function')
    },
    scan: function () {
      var that = this
      // eslint-disable-next-line
      cordova.plugins.barcodeScanner.scan(
        function (result) {
          that.room = result.text
        },
        function (error) {
          alert('Scanning failed: ' + error)
        }, {
          preferFrontCamera: true,
          showFlipCameraButton: true
        }
      )
    }
  }
}
</script>

<style scoped>
  .datepicker {
    padding:.75rem 1.5rem;
  }
  .scan-now {
    float:right;
    margin-top:-10px;
  }
</style>
